import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

class BootstrapPagination extends React.Component {
    render() {
        let pagination = [];
        const totalPages = this.props.totalPages;
        const currentPage = this.props.currentPage;
        const offset = 2;
        let skipped = false;

        let setPage = (page) => {
            let newFilter = {...this.props.filter, page: page};
            this.props.fetch(newFilter);
        };

        if (totalPages > 0) {
            pagination.push((
                <PaginationItem disabled={currentPage < 2} key='-1'>
                    <PaginationLink onClick={() => setPage(currentPage - 1)}><FontAwesomeIcon icon={['far', 'angle-left']}/></PaginationLink>
                </PaginationItem>
            ));
        }

        for (let i = 1; i <= totalPages; i++) {
            if ( i <= offset || i > (totalPages - offset) || ( i >= ( currentPage - offset ) && i <= ( currentPage + offset ) ) ) {

                pagination.push((
                    <PaginationItem active={i === currentPage} key={i}>
                        <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
                    </PaginationItem>
                ));
                skipped = false;
            } else {
                if (skipped) {
                    continue;
                }

                skipped = true;
                pagination.push((
                    <PaginationItem disabled key={i}>
                        <PaginationLink>...</PaginationLink>
                    </PaginationItem>
                ));
            }
        }

        if (totalPages > 0) {
            pagination.push((
                <PaginationItem disabled={currentPage > (totalPages - 1)} key='+1'>
                    <PaginationLink onClick={() => setPage(currentPage + 1)}><FontAwesomeIcon icon={['far', 'angle-right']}/></PaginationLink>
                </PaginationItem>
            ));
        }

        return (
            <Pagination>
                { pagination }
            </Pagination>
        );
    }
}

export default BootstrapPagination;
